import { SxProps, Theme } from '@mui/material';

export const TOOLTIP_PADDING = 24;
export const TOOLTIP_MAX_WIDTH = 480;
export const TOOLTIP_MIN_WIDTH = 120;
export const TOOLTIP_FONT_SIZE = '14px';
export const TOOLTIP_ICON_SIZE = 24;
export const TOOLTIP_GAP_BETWEEN_ICON_AND_TEXT = 5;

export const tooltipStyles = ({
  type,
}: {
  type: 'error' | 'warning';
}): SxProps<Theme> => ({
  boxSizing: 'border-box',
  padding: '12px',
  bgcolor: type === 'error' ? 'customColors.pink.100' : '#fef2eb',
  color: 'customColors.gray.950',
  fontSize: TOOLTIP_FONT_SIZE,
  fontWeight: '400',
  width: 'max-content',
  minWidth: TOOLTIP_MIN_WIDTH,
  maxWidth: TOOLTIP_MAX_WIDTH,
  marginBottom: '24px !important',
  overflowWrap: 'break-word',
  boxShadow: '0 9px 12px -3px rgba(0, 0, 0, 0.2)',
  '& .MuiTooltip-arrow': {
    color: type === 'error' ? 'customColors.pink.100' : '#fef2eb',
  },
  '@media (max-width: 768px)': {
    maxWidth: 320,
  },
});

export const tooltipSingleTextStyles: SxProps<Theme> = {
  fontSize: 'inherit',
  textWrap: 'wrap',
};

export const tooltipListStyles: SxProps<Theme> = {
  padding: 0,
  margin: 0,
  listStyle: 'none',
};

export const tooltipIconStyles: SxProps<Theme> = {
  display: 'inline-flex',
  marginTop: '-3px',
};

export const tooltipListItemStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: `${TOOLTIP_GAP_BETWEEN_ICON_AND_TEXT}px`,
  marginBottom: '7px',
  lineHeight: '17px',
  '&:last-of-type': {
    marginBottom: 0,
  },
};

export const tooltipItemTextStyles: SxProps<Theme> = {
  flex: 1,
  fontSize: 'inherit',
  lineHeight: '17px',
  textWrap: 'wrap',
};
